import React from 'react';
import { Modal, ModalBody, Button, FormGroup, Input, Label } from 'reactstrap';

class CancelModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = { stage: 1, selectedReasonId: null };
  }

  handleProceed = () => {
    this.setState({ stage: 2 });
  };

  handleConfirm = () => {
    const { onConfirm } = this.props;
    const { selectedReasonId } = this.state;
    if (selectedReasonId) {
      onConfirm(selectedReasonId);
    }
  };

  handleClose = () => {
    const { onClose } = this.props;
    this.setState({ stage: 1, selectedReasonId: null });
    onClose();
  };

  render() {
    const { isOpen, cancellationReasons } = this.props;
    const { stage, selectedReasonId } = this.state;

    return (
      <Modal isOpen={isOpen} toggle={this.handleClose}>
        <ModalBody className="p-4">
          {stage === 1 ? (
            <div>
              <h5 className="mb-3">Are you sure you want to stop auto renew?</h5>
              <p className="text-muted small mb-3">
                Macrostax offers exclusive features to help you reach your goals:
              </p>
              <ul className="text-muted small mb-3" style={{ paddingLeft: '1.25rem' }}>
                <li className="mb-2">Free nutrition coaching in the app with StaxChat</li>
                <li className="mb-2">Customized meals and recipes that fit your macros</li>
                <li className="mb-2">Ability to switch plans and macros with no additional fees</li>
              </ul>
              <p className="text-muted small mb-4">
                Your account will remain active until the end of your current billing cycle.
              </p>
              <Button color="primary" size="lg" block className="mb-3" onClick={this.handleProceed}>
                Please Cancel
              </Button>
              <Button outline color="primary" size="lg" block onClick={this.handleClose}>
                I&apos;ll Stay!
              </Button>
            </div>
          ) : (
            <div>
              <h5 className="mb-3">We&apos;re sad to see you go.</h5>
              <p className="text-muted mb-3">
                Please let us know why you&apos;ve decided to cancel:
              </p>
              {cancellationReasons.map((reason) => (
                <FormGroup check key={reason.id}>
                  <Label check>
                    <Input
                      type="radio"
                      name="cancellationReason"
                      value={reason.id}
                      checked={selectedReasonId === reason.id}
                      onChange={() => this.setState({ selectedReasonId: reason.id })}
                    />
                    {' '}
                    {reason.content}
                  </Label>
                </FormGroup>
              ))}
              <div className="mt-4">
                <Button
                  color="danger"
                  size="lg"
                  block
                  className="mb-3"
                  onClick={this.handleConfirm}
                  disabled={!selectedReasonId}
                >
                  Please Cancel
                </Button>
                <Button outline color="primary" size="lg" block onClick={this.handleClose}>
                  I&apos;ll Stay!
                </Button>
              </div>
            </div>
          )}
        </ModalBody>
      </Modal>
    );
  }
}

export default CancelModal;
